import {Map} from "immutable";
import {createRequestTypes, createSubmitRequestTypes} from "./helpers";

export const LOAD_WATER_PALLETS = createRequestTypes("INVENTORY:LOAD_WATER_PALLETS");
export const REQUEST_RECORD_WATER_TEST_RESULT_INPUT = "INVENTORY:REQUEST_RECORD_WATER_TEST_RESULT_INPUT"
export const RECORD_WATER_TEST_RESULT = createSubmitRequestTypes("INVENTORY:RECORD_WATER_TEST_RESULT");
export const REQUEST_WATER_CONTAINER_INFO = "INVENTORY:REQUEST_WATER_CONTAINER_INFO";

export const HANDLE_INCOMING_EVENT = "INVENTORY:HANDLE_INCOMING_EVENT";
export const handleIncomingInventoryEvent = (event, payload) => ({ type: HANDLE_INCOMING_EVENT, event, payload });


export const REQUEST_REGISTER_WATER_PALLET = "INVENTORY:REQUEST_REGISTER_WATER_PALLET";
export const requestRegisterWaterPallet = () => ({ type: REQUEST_REGISTER_WATER_PALLET });
export const REGISTER_WATER_PALLET = createSubmitRequestTypes("INVENTORY:REGISTER_WATER_PALLET");
export const cancelRegisterWaterPallet = () => ({ type: REGISTER_WATER_PALLET.CANCEL });
export const registerWaterPallet = (data, formName) => ({ type: REGISTER_WATER_PALLET.SUBMIT, data, formName });

export const REQUEST_RECORD_WATER_TEST_RESULT_FOR_PALLETS_INPUT = "INVENTORY:REQUEST_RECORD_WATER_TEST_RESULT_FOR_PALLETS_INPUT";
export const requestRecordWaterTestResultForPalletsInput = () => ({ type: REQUEST_RECORD_WATER_TEST_RESULT_FOR_PALLETS_INPUT });
export const RECORD_WATER_TEST_RESULT_FOR_PALLETS = createSubmitRequestTypes("INVENTORY:RECORD_WATER_TEST_RESULT_FOR_PALLETS");
export const cancelRecordWaterTestResultForPallets = () => ({ type: RECORD_WATER_TEST_RESULT_FOR_PALLETS.CANCEL });

// Warehouses.
export const LOAD_WAREHOUSE = createRequestTypes("INVENTORY:LOAD_WAREHOUSE");
export const loadWarehouse = (id) => ({ type: LOAD_WAREHOUSE.LOAD, id: id });
export const LOAD_WAREHOUSES = createRequestTypes("INVENTORY:LOAD_WAREHOUSES");
export const loadWarehouses = (meta = Map()) => ({ type: LOAD_WAREHOUSES.LOAD, meta });

export const REQUEST_RENAME_WAREHOUSE = "INVENTORY:REQUEST_RENAME_WAREHOUSE";
export const RENAME_WAREHOUSE = createSubmitRequestTypes("INVENTORY:RENAME_WAREHOUSE");
export const requestRenameWarehouse = (id) => ({ type: REQUEST_RENAME_WAREHOUSE, id });
export const cancelRenameWarehouse = () => ({ type: RENAME_WAREHOUSE.CANCEL });
export const renameWarehouse = (data) => ({ type: RENAME_WAREHOUSE.SUBMIT, data: data });

export const REQUEST_REGISTER_WAREHOUSE = "INVENTORY:REQUEST_REGISTER_WAREHOUSE";
export const REGISTER_WAREHOUSE = createSubmitRequestTypes("INVENTORY:REGISTER_WAREHOUSE");
export const requestRegisterWarehouse = (id) => ({ type: REQUEST_REGISTER_WAREHOUSE, id });
export const cancelRegisterWarehouse = () => ({ type: REGISTER_WAREHOUSE.CANCEL });
export const registerWarehouse = (data, formName) => ({ type: REGISTER_WAREHOUSE.SUBMIT, data, formName});

export const REQUEST_CHANGE_WAREHOUSE_ADDRESS = "INVENTORY:REQUEST_CHANGE_WAREHOUSE_ADDRESS";
export const CHANGE_WAREHOUSE_ADDRESS = createSubmitRequestTypes("INVENTORY:CHANGE_WAREHOUSE_ADDRESS");
export const requestChangeWarehouseAddress = (id) => ({ type: REQUEST_CHANGE_WAREHOUSE_ADDRESS, id });
export const cancelChangeWarehouseAddress = () => ({ type: CHANGE_WAREHOUSE_ADDRESS.CANCEL });
export const changeWarehouseAddress = (data, formName) => ({ type: CHANGE_WAREHOUSE_ADDRESS.SUBMIT, data, formName });

export const REQUEST_CHANGE_WAREHOUSE_CONTACT = "INVENTORY:REQUEST_CHANGE_WAREHOUSE_CONTACT";
export const CHANGE_WAREHOUSE_CONTACT = createSubmitRequestTypes("INVENTORY:CHANGE_WAREHOUSE_CONTACT");
export const requestChangeWarehouseContact = (id) => ({ type: REQUEST_CHANGE_WAREHOUSE_CONTACT, id });
export const cancelChangeWarehouseContact = () => ({ type: CHANGE_WAREHOUSE_CONTACT.CANCEL });
export const changeWarehouseContact = (data, formName) => ({ type: CHANGE_WAREHOUSE_CONTACT.SUBMIT, data, formName });

// Stock Filter.
export const SET_STOCK_WAREHOUSE_FILTER = "INVENTORY:SET_STOCK_WAREHOUSE_FILTER";
export const setStockWarehouseFilter = (filter) => ({ type: SET_STOCK_WAREHOUSE_FILTER, filter });

// Request GUI window for adding stock to warehouse.
export const ADD_STOCK_TO_WAREHOUSE = createSubmitRequestTypes("INVENTORY:ADD_STOCK_TO_WAREHOUSE");
export const REQUEST_ADD_STOCK_TO_WAREHOUSE = "INVENTORY:REQUEST_ADD_STOCK_TO_WAREHOUSE";
export const requestAddStockToWarehouse = (id) => ({ type: REQUEST_ADD_STOCK_TO_WAREHOUSE, id });
export const cancelAddStockToWarehouse = () => ({ type: ADD_STOCK_TO_WAREHOUSE.CANCEL });
export const addStockToWarehouse = (data, formName) => ({ type: ADD_STOCK_TO_WAREHOUSE.SUBMIT, data, formName });

// Request GUI window for removing stock to warehouse.
export const REMOVE_STOCK_FROM_WAREHOUSE = createSubmitRequestTypes("INVENTORY:REMOVE_STOCK_FROM_WAREHOUSE");
export const REQUEST_REMOVE_STOCK_FROM_WAREHOUSE = "INVENTORY:REQUEST_REMOVE_STOCK_FROM_WAREHOUSE";
export const requestRemoveStockFromWarehouse = (id) => ({ type: REQUEST_REMOVE_STOCK_FROM_WAREHOUSE, id });
export const cancelRemoveStockFromWarehouse = () => ({ type: REMOVE_STOCK_FROM_WAREHOUSE.CANCEL });
export const removeStockFromWarehouse = (data, formName) => ({ type: REMOVE_STOCK_FROM_WAREHOUSE.SUBMIT, data, formName });

// Products
export const LOAD_STOCK_ITEMS = createRequestTypes("INVENTORY:LOAD_STOCK_ITEMS");
export const LOAD_STOCK_ITEM = createRequestTypes("INVENTORY:LOAD_STOCK_ITEM");
export const LOAD_PRODUCTS = createRequestTypes("INVENTORY:LOAD_PRODUCTS");
export const LOAD_PRODUCT = createRequestTypes("INVENTORY:LOAD_PRODUCT");
export const loadStockItems = (meta = Map()) => ({ type: LOAD_STOCK_ITEMS.LOAD, meta });
export const loadStockItem = (sku) => ({ type: LOAD_STOCK_ITEMS.LOAD, sku });
export const loadProducts = (meta = Map()) => ({ type: LOAD_PRODUCTS.LOAD, meta });
export const loadProduct = (code) => ({ type: LOAD_PRODUCT.LOAD, code });

export const REQUEST_CREATE_PRODUCT = "INVENTORY:REQUEST_CREATE_PRODUCT";
export const requestCreateProduct = () => ({ type: REQUEST_CREATE_PRODUCT });
export const CREATE_PRODUCT = createSubmitRequestTypes("INVENTORY:CREATE_PRODUCT");
export const cancelCreateProduct = () => ({ type: CREATE_PRODUCT.CANCEL });

export const REQUEST_CREATE_PRODUCT_BUNDLE = "INVENTORY:REQUEST_CREATE_PRODUCT_BUNDLE";
export const requestCreateProductBundle = () => ({ type: REQUEST_CREATE_PRODUCT_BUNDLE });
export const CREATE_PRODUCT_BUNDLE = createSubmitRequestTypes("INVENTORY:CREATE_PRODUCT_BUNDLE");
export const cancelCreateProductBundle = () => ({ type: CREATE_PRODUCT_BUNDLE.CANCEL });



export const REQUEST_ADD_STOCK = "INVENTORY:REQUEST_ADD_STOCK";
export const requestAddStock = (warehouseId) => ({ type: REQUEST_ADD_STOCK, warehouseId });
export const ADD_STOCK = createSubmitRequestTypes("INVENTORY:ADD_STOCK");
export const cancelAddStock = () => ({ type: ADD_STOCK.CANCEL });

export const REQUEST_REMOVE_STOCK = "INVENTORY:REQUEST_REMOVE_STOCK";
export const requestRemoveStock = (warehouseId) => ({ type: REQUEST_REMOVE_STOCK, warehouseId });
export const REMOVE_STOCK = createSubmitRequestTypes("INVENTORY:REMOVE_STOCK");
export const cancelRemoveStock = () => ({ type: REMOVE_STOCK.CANCEL });



export const REQUEST_ADD_PRODUCT_VARIATION = "INVENTORY:REQUEST_ADD_PRODUCT_VARIATION";
export const requestAddProductVariation = (code) => ({ type: REQUEST_ADD_PRODUCT_VARIATION, code });
export const ADD_PRODUCT_VARIATION = createSubmitRequestTypes("INVENTORY:ADD_PRODUCT_VARIATION");
export const addProductVariation = (data, formName) => ({ type: ADD_PRODUCT_VARIATION.SUBMIT, data, formName });
export const cancelAddProductVariation = () => ({ type: ADD_PRODUCT_VARIATION.CANCEL });

export const REQUEST_ADD_PRODUCT_SIZE = "INVENTORY:REQUEST_ADD_PRODUCT_SIZE";
export const requestAddProductSize = (code) => ({ type: REQUEST_ADD_PRODUCT_SIZE, code });
export const ADD_PRODUCT_SIZE = createSubmitRequestTypes("INVENTORY:ADD_PRODUCT_SIZE");
export const addProductSize = (data, formName) => ({ type: ADD_PRODUCT_SIZE.SUBMIT, data, formName });
export const cancelAddProductSize = () => ({ type: ADD_PRODUCT_SIZE.CANCEL });

export const REQUEST_CREATE_PRODUCT_CONFIGURATION = "INVENTORY:REQUEST_CREATE_PRODUCT_CONFIGURATION";
export const requestCreateProductConfiguration = (code) => ({ type: REQUEST_CREATE_PRODUCT_CONFIGURATION, code });
export const CREATE_PRODUCT_CONFIGURATION = createSubmitRequestTypes("INVENTORY:CREATE_PRODUCT_CONFIGURATION");
export const createProductConfiguration = (data, formName) => ({ type: CREATE_PRODUCT_CONFIGURATION.SUBMIT, data, formName });
export const cancelCreateProductConfiguration = () => ({ type: CREATE_PRODUCT_CONFIGURATION.CANCEL });

export const REQUEST_CHANGE_PRODUCT_DESCRIPTION = "INVENTORY:REQUEST_CHANGE_PRODUCT_DESCRIPTION";
export const requestChangeProductDescription = (sku) => ({ type: REQUEST_CHANGE_PRODUCT_DESCRIPTION, sku });
export const CHANGE_PRODUCT_DESCRIPTION = createSubmitRequestTypes("INVENTORY:CHANGE_PRODUCT_DESCRIPTION");
export const changeProductDescription = (data, formName) => ({ type: CHANGE_PRODUCT_DESCRIPTION.SUBMIT, data, formName });
export const cancelChangeProductDescription = () => ({ type: CHANGE_PRODUCT_DESCRIPTION.CANCEL });

export const REQUEST_CHANGE_PRODUCT_BUNDLE_DESCRIPTION = "INVENTORY:REQUEST_CHANGE_PRODUCT_BUNDLE_DESCRIPTION";
export const requestChangeProductBundleDescription = (sku) => ({ type: REQUEST_CHANGE_PRODUCT_BUNDLE_DESCRIPTION, sku });
export const CHANGE_PRODUCT_BUNDLE_DESCRIPTION = createSubmitRequestTypes("INVENTORY:CHANGE_PRODUCT_BUNDLE_DESCRIPTION");
export const changeProductBundleDescription = (data, formName) => ({ type: CHANGE_PRODUCT_BUNDLE_DESCRIPTION.SUBMIT, data, formName });
export const cancelChangeProductBundleDescription = () => ({ type: CHANGE_PRODUCT_BUNDLE_DESCRIPTION.CANCEL });

export const REQUEST_CHANGE_PRODUCT_MEASUREMENTS = "INVENTORY:REQUEST_CHANGE_PRODUCT_MEASUREMENTS";
export const requestChangeProductMeasurements = (sku) => ({ type: REQUEST_CHANGE_PRODUCT_MEASUREMENTS, sku });
export const CHANGE_PRODUCT_MEASUREMENTS = createSubmitRequestTypes("INVENTORY:CHANGE_PRODUCT_MEASUREMENTS");
export const changeProductMeasurements = (data, formName) => ({ type: CHANGE_PRODUCT_MEASUREMENTS.SUBMIT, data, formName });
export const cancelChangeProductMeasurements = () => ({ type: CHANGE_PRODUCT_MEASUREMENTS.CANCEL });

export const REQUEST_ADD_PRODUCT_TO_BUNDLE = "INVENTORY:REQUEST_ADD_PRODUCT_TO_BUNDLE";
export const requestAddProductToBundle = (sku) => ({ type: REQUEST_ADD_PRODUCT_TO_BUNDLE, sku });
export const ADD_PRODUCT_TO_BUNDLE = createSubmitRequestTypes("INVENTORY:ADD_PRODUCT_TO_BUNDLE");
export const addProductToBundle = (data, formName) => ({ type: ADD_PRODUCT_TO_BUNDLE.SUBMIT, data, formName });
export const cancelAddProductToBundle = () => ({ type: ADD_PRODUCT_TO_BUNDLE.CANCEL });

export const REQUEST_REMOVE_PRODUCT_FROM_BUNDLE = "INVENTORY:REQUEST_REMOVE_PRODUCT_FROM_BUNDLE";
export const requestRemoveProductFromBundle = (sku) => ({ type: REQUEST_REMOVE_PRODUCT_FROM_BUNDLE, sku });
export const REMOVE_PRODUCT_FROM_BUNDLE = createSubmitRequestTypes("INVENTORY:REMOVE_PRODUCT_FROM_BUNDLE");
export const removeProductFromBundle = (data, formName) => ({ type: REMOVE_PRODUCT_FROM_BUNDLE.SUBMIT, data, formName });
export const cancelRemoveProductFromBundle = () => ({ type: REMOVE_PRODUCT_FROM_BUNDLE.CANCEL });

export const REQUEST_CHANGE_AVAILABILITY_FOR_LOCATION = "INVENTORY:REQUEST_CHANGE_AVAILABILITY_FOR_LOCATION";
export const requestChangeAvailabilityForLocation = (shopId, kind, code, name) => ({ type: REQUEST_CHANGE_AVAILABILITY_FOR_LOCATION, shopId, kind, code, name});
export const CHANGE_AVAILABILITY_FOR_LOCATION = createSubmitRequestTypes("INVENTORY:CHANGE_AVAILABILITY_FOR_LOCATION");
export const cancelChangeAvailabilityForLocation = () => ({ type: CHANGE_AVAILABILITY_FOR_LOCATION.CANCEL });


export const REQUEST_ADD_PRODUCT_TO_SHOP = "INVENTORY:REQUEST_ADD_PRODUCT_TO_SHOP";
export const requestAddProductToShop = (shopId, shopTitle) => ({ type: REQUEST_ADD_PRODUCT_TO_SHOP, shopId, shopTitle });
export const ADD_PRODUCT_TO_SHOP = createSubmitRequestTypes("INVENTORY:ADD_PRODUCT_TO_SHOP");
export const cancelAddProductToShop = () => ({ type: ADD_PRODUCT_TO_SHOP.CANCEL });

export const REQUEST_REMOVE_PRODUCT_FROM_SHOP = "INVENTORY:REQUEST_REMOVE_PRODUCT_FROM_SHOP";
export const requestRemoveProductFromShop = (shopId, productId) => ({ type: REQUEST_REMOVE_PRODUCT_FROM_SHOP, shopId, productId });
export const REMOVE_PRODUCT_FROM_SHOP = createSubmitRequestTypes("INVENTORY:REMOVE_PRODUCT_FROM_SHOP");
export const cancelRemoveProductFromShop = () => ({ type: REMOVE_PRODUCT_FROM_SHOP.CANCEL });

export const REQUEST_CHANGE_PRODUCT_PRICING = "INVENTORY:REQUEST_CHANGE_PRODUCT_PRICING";
export const requestChangeProductPricing = (shopId, productId) => ({ type: REQUEST_CHANGE_PRODUCT_PRICING, shopId, productId });
export const CHANGE_PRODUCT_PRICING = createSubmitRequestTypes("INVENTORY:CHANGE_PRODUCT_PRICING");
export const cancelChangeProductPricing = () => ({ type: CHANGE_PRODUCT_PRICING.CANCEL });

export const REQUEST_CHANGE_SUBSCRIPTION_PRODUCT_PRICING = "INVENTORY:REQUEST_CHANGE_SUBSCRIPTION_PRODUCT_PRICING";
export const requestChangeSubscriptionProductPricing = (shopId, productId) => ({ type: REQUEST_CHANGE_SUBSCRIPTION_PRODUCT_PRICING, shopId, productId });
export const CHANGE_SUBSCRIPTION_PRODUCT_PRICING = createSubmitRequestTypes("INVENTORY:CHANGE_SUBSCRIPTION_PRODUCT_PRICING");
export const cancelChangeSubscriptionProductPricing = () => ({ type: CHANGE_SUBSCRIPTION_PRODUCT_PRICING.CANCEL });

export const REQUEST_COMMIT_PRODUCT_PRICELIST = "INVENTORY:REQUEST_COMMIT_PRODUCT_PRICELIST";
export const requestCommitProductPricelist = (shopId) => ({ type: REQUEST_COMMIT_PRODUCT_PRICELIST, shopId });
export const COMMIT_PRODUCT_PRICELIST = createSubmitRequestTypes("INVENTORY:COMMIT_PRODUCT_PRICELIST");
export const cancelCommitProductPricelist = () => ({ type: COMMIT_PRODUCT_PRICELIST.CANCEL });

export const REQUEST_COMMIT_SUBSCRIPTION_PRICELIST = "INVENTORY:REQUEST_COMMIT_SUBSCRIPTION_PRICELIST";
export const requestCommitSubscriptionPricelist = (shopId) => ({ type: REQUEST_COMMIT_SUBSCRIPTION_PRICELIST, shopId });
export const COMMIT_SUBSCRIPTION_PRICELIST = createSubmitRequestTypes("INVENTORY:COMMIT_SUBSCRIPTION_PRICELIST");
export const cancelCommitSubscriptionPricelist = () => ({ type: COMMIT_SUBSCRIPTION_PRICELIST.CANCEL });

export const REQUEST_APPLY_PRODUCT_SURCHARGE = "INVENTORY:REQUEST_APPLY_PRODUCT_SURCHARGE";
export const requestApplyProductSurcharge = (shopId, productId) => ({ type: REQUEST_APPLY_PRODUCT_SURCHARGE, shopId, productId });
export const APPLY_PRODUCT_SURCHARGE = createSubmitRequestTypes("INVENTORY:APPLY_PRODUCT_SURCHARGE");
export const cancelApplyProductSurcharge = () => ({ type: APPLY_PRODUCT_SURCHARGE.CANCEL });

export const REQUEST_EDIT_PRODUCT_SURCHARGE = "INVENTORY:REQUEST_EDIT_PRODUCT_SURCHARGE";
export const requestEditProductSurcharge = (shopId, productId, countryCode, stateCode) => ({ type: REQUEST_EDIT_PRODUCT_SURCHARGE, shopId, productId, countryCode, stateCode });
export const EDIT_PRODUCT_SURCHARGE = createSubmitRequestTypes("INVENTORY:EDIT_PRODUCT_SURCHARGE");
export const cancelEditProductSurcharge = () => ({ type: EDIT_PRODUCT_SURCHARGE.CANCEL });

export const REQUEST_REJECT_WATER_CONTAINER = "INVENTORY:REQUEST_REJECT_WATER_CONTAINER";
export const requestRejectWaterContainer = (palletId, serial) => ({ type: REQUEST_REJECT_WATER_CONTAINER, palletId, serial });
export const REJECT_WATER_CONTAINER = createSubmitRequestTypes("INVENTORY:REJECT_WATER_CONTAINER");
export const cancelRejectWaterContainer = () => ({ type: REJECT_WATER_CONTAINER.CANCEL });

export const REQUEST_ADD_WATER_CONTAINER_TO_PALLET = "INVENTORY:REQUEST_ADD_WATER_CONTAINER_TO_PALLET";
export const requestAddWaterContainerToPallet = (palletId) => ({ type: REQUEST_ADD_WATER_CONTAINER_TO_PALLET, palletId });
export const ADD_WATER_CONTAINER_TO_PALLET = createSubmitRequestTypes("INVENTORY:ADD_WATER_CONTAINER_TO_PALLET");
export const cancelAddWaterContainerToPallet = () => ({ type: ADD_WATER_CONTAINER_TO_PALLET.CANCEL });

export const REQUEST_REGISTER_OTHER_PALLET = "INVENTORY:REQUEST_REGISTER_OTHER_PALLET";
export const requestRegisterOtherPallet = () => ({ type: REQUEST_REGISTER_OTHER_PALLET });
export const REGISTER_OTHER_PALLET = createSubmitRequestTypes("INVENTORY:REGISTER_OTHER_PALLET");
export const cancelRegisterOtherPallet = () => ({ type: REGISTER_OTHER_PALLET.CANCEL });

export const REQUEST_MODIFY_OTHER_PALLET = "INVENTORY:REQUEST_MODIFY_OTHER_PALLET";
export const requestModifyOtherPallet = (palletId) => ({ type: REQUEST_MODIFY_OTHER_PALLET, palletId });
export const MODIFY_OTHER_PALLET = createSubmitRequestTypes("INVENTORY:MODIFY_OTHER_PALLET");
export const cancelModifyOtherPallet = () => ({ type: MODIFY_OTHER_PALLET.CANCEL });

export const REQUEST_CHANGE_US_TAX_SETTING = "INVENTORY:REQUEST_CHANGE_US_TAX_SETTING";
export const requestChangeUsTaxSetting = (stateCode, name) => ({ type: REQUEST_CHANGE_US_TAX_SETTING, stateCode, name });
export const CHANGE_US_TAX_SETTING = createSubmitRequestTypes("INVENTORY:CHANGE_US_TAX_SETTING");
export const cancelChangeUsTaxSetting = () => ({ type: CHANGE_US_TAX_SETTING.CANCEL });

export const REQUEST_SET_OPERATION_HOURS = "INVENTORY:REQUEST_SET_OPERATION_HOURS";
export const requestSetOperationHours = (id) => ({ type: REQUEST_SET_OPERATION_HOURS, id });
export const SET_OPERATION_HOURS = createSubmitRequestTypes("INVENTORY:SET_OPERATION_HOURS");
export const cancelSetOperationHours = () => ({ type: SET_OPERATION_HOURS.CANCEL });

export const REQUEST_ASSIGN_WAREHOUSE_BACKUP = "INVENTORY:REQUEST_ASSIGN_WAREHOUSE_BACKUP";
export const requestAssignWarehouseBackup = (id) => ({ type: REQUEST_ASSIGN_WAREHOUSE_BACKUP, id });
export const ASSIGN_WAREHOUSE_BACKUP = createSubmitRequestTypes("INVENTORY:ASSIGN_WAREHOUSE_BACKUP");
export const cancelAssignWarehouseBackup = () => ({ type: ASSIGN_WAREHOUSE_BACKUP.CANCEL });

export const SCAN_BARCODE = createSubmitRequestTypes("INVENTORY:SCAN_BARCODE");
export const REQUEST_SCAN_BARCODE = "INVENTORY:REQUEST_SCAN_BARCODE";
export const requestScanBarcode = (warehouseId, packageId) => ({ type: REQUEST_SCAN_BARCODE, warehouseId, packageId });
export const cancelScanBarcode = () => ({ type: SCAN_BARCODE.CANCEL });
export const scanBarcodeSuccess = () => ({ type: SCAN_BARCODE.SUCCESS });
export const scanBarcode = (data, formName) => ({ type: SCAN_BARCODE.SUBMIT, data, formName });

// No submit for order detail window
export const ORDER_DETAIL = createSubmitRequestTypes("INVENTORY:ORDER_DETAIL");
export const REQUEST_ORDER_DETAIL = "INVENTORY:REQUEST_ORDER_DETAIL";
export const cancelOrderDetail = () => ({ type: ORDER_DETAIL.CANCEL });
export const requestOrderDetail = (warehouseId, jobId) => ({ type: REQUEST_ORDER_DETAIL, warehouseId, jobId });



export const REQUEST_REMOVE_PRODUCT = "INVENTORY:REQUEST_REMOVE_PRODUCT";
export const requestRemoveProduct = (code) => ({ type: REQUEST_REMOVE_PRODUCT, code });
export const REMOVE_PRODUCT = createSubmitRequestTypes("INVENTORY:REMOVE_PRODUCT");
export const removeProduct = (data, formName) => ({ type: REMOVE_PRODUCT.SUBMIT, data, formName });
export const cancelRemoveProduct = () => ({type: REMOVE_PRODUCT.CANCEL });
export const REMOVED_PRODUCT = "INVENTORY:REMOVED_PRODUCT";
export const removedProduct = (code) => ({ type: REMOVED_PRODUCT, code })

export const REQUEST_ADD_PRODUCT_TO_INVENTORY = "INVENTORY:REQUEST_ADD_PRODUCT_TO_INVENTORY";
export const requestAddProductToInventory = (code, sku) => ({ type: REQUEST_ADD_PRODUCT_TO_INVENTORY, code, sku });
export const ADD_PRODUCT_TO_INVENTORY = createSubmitRequestTypes("INVENTORY:ADD_PRODUCT_TO_INVENTORY");
export const addProductToInventory = (data, formName) => ({ type: ADD_PRODUCT_TO_INVENTORY.SUBMIT, data, formName });
export const cancelAddProductToInventory = () => ({type: ADD_PRODUCT_TO_INVENTORY.CANCEL });


// TEST
export const SAY_HELLO = "INVENTORY:SAY_HELLO";
export function sayHello(name) {
  return {
    type: SAY_HELLO,
    name
  }
}

export const recordWaterTestResult = (data) => ({ type: RECORD_WATER_TEST_RESULT.SUBMIT, data });
export const recordWaterTestResultSubmitting = (pallet_id) => ({ type: RECORD_WATER_TEST_RESULT.SUBMITTING, pallet_id });
export const recordWaterTestResultSuccess = (pallet_id) => ({ type: RECORD_WATER_TEST_RESULT.SUCCESS, pallet_id });
export const recordWaterTestResultFailed = (pallet_id) => ({ type: RECORD_WATER_TEST_RESULT.FAILED, pallet_id });
export const cancelRecordWaterTestResult = () => ({ type: RECORD_WATER_TEST_RESULT.CANCEL });

export function requestRecordWaterTestResultInput(pallet_id) {
  return {
    type: REQUEST_RECORD_WATER_TEST_RESULT_INPUT,
    pallet_id
  }
}

export function requestWaterContainerInfo(serialNumber) {
  return {
    type: REQUEST_WATER_CONTAINER_INFO,
    serialNumber
  }
}

export function loadWaterPallets(meta = Map()) {
  return {
    type: LOAD_WATER_PALLETS.LOAD,
    meta
  }
}

export function loadWaterPalletsLoading() {
  return {
    type: LOAD_WATER_PALLETS.LOADING
  }
}

export function loadWaterPalletsSuccess(entities, result) {
  return {
    type: LOAD_WATER_PALLETS.SUCCESS,
    entities, result
  }
}

export function loadWaterPalletsFailed() {
  return {
    type: LOAD_WATER_PALLETS.FAILED
  }
}
